import React, { useState, useEffect } from 'react'
import styles from './statusscree.module.css'

const StatusScreen = () => {
    const [timer, setTimer] = useState(3);
    const [showFailedMessage, setShowFailedMessage] = useState(false)

    useEffect(()=>{
        if(timer > 0){
            const interval = setInterval(() => {
                setTimer(timer-1);
            }, 1000);
    
            return () => clearInterval(interval);
        }
        else {
            const timeout = setTimeout(() => {
                setShowFailedMessage(true);
            }, 2000);
            return () => clearTimeout(timeout);
        }

    },[timer])

    useEffect(() => {
        setTimeout(() => {
            window.close()
        },3000)
    },[])


    return (
        <>  
            <div className={styles.statusScreenContainer}>
                <div className={styles.statusMessage}>
                </div>
                <div className={styles.statusTimerMessage}>Redirecting you in...</div>
                <div className={styles.statusTimer}>{timer}</div>
                {timer === 0 && showFailedMessage? <><div className={styles.redirectionFailedHeading}>Redirection failed </div>
                <div className={styles.redirectionFailedSubHeading}>Kindly close this tab and resume your transaction.</div></>: <div>Please do not refresh</div>}
            </div>
        </>
    )
}

export default StatusScreen
